export const textFieldProps = {
  style : {
    fontSize: 20
  }
};

export const inputLabel = 'Beet name';

export const modalPadding = {
  pt: 2,
  px: 4,
  pb: 3,
};

export const enterKey = 'Enter';